/**
 * splide.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";
import { Splide } from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';

(function ($, Drupal, drupalSettings) {

  'use strict';

  var splideVideo;

  Drupal.behaviors.splideVideo = {

    attach: function (context, settings) {

      once('loadSplideVideo', 'div.saipem--container.saipem-video', context).forEach(function(element){
        const rowPerPage = $(element).attr('data-rowperpage');
        const id = $(element).attr('id');

        $(element).find('.splide-video-container').on('click',{rowPerPage:rowPerPage,id:id}, function(e){

          let idRownum = $(this).attr('data-index');
          const currentVideo = (parseInt(idRownum) - 1) % parseInt(e.data.rowPerPage);

          $(this).closest('.saipem--container.saipem-video').find('.splide-popup-container').show();
          $('body').addClass('modal-open');

          console.log('DEBUG', e.data);
          let selector = document.getElementById(e.data.id+'-popup');
          if (selector) {
            splideVideo = new Splide( selector, {
              heightRatio: 0.5625,
              cover: false,
              start : currentVideo,
              // fixedWidth : '854px',
              // fixedHeight: '480px',
              perPage: 1,
              gap : '1rem',
              pagination: false,
              video: {
                autoplay: false,
                loop : false,
                mute: true,
                playerOptions: {
                  youtube: { },
                },
              },
            });

            splideVideo.mount( { Video } );
          }
        });

        $(element).closest('.saipem--container.saipem-video').find('.splide-popup-close').on('click',function(e){
            e.preventDefault();
            $('body').removeClass('modal-open');
            $(document).find('.splide-popup-container').hide();
            splideVideo.destroy( true );
        });
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
